module.exports = __webpack_public_path__ + "img/icon2.34be6bb8.png";